export const FilenamePattern = /^([a-z0-9]+)?(_([a-z0-9]+)?(_([0-9]+))?)?\..+$/
